import { GetterTree } from 'vuex'
import { State, Campaign } from './state'

export type Getters = {
  totalCampaignCount(state: State): number;
  totalVisibleCampaignCount(state: State): number;
  totalCategories(state: State): number;
  totalVersions(state: State): number;
  totalSections(state: State): number;
  getCampaignById(state: State): (id: number) => Campaign | undefined;
}

export const getters: GetterTree<State, State> & Getters = {
  totalCampaignCount(state) {
    return state.data.length
  },
  totalVisibleCampaignCount(state) {
    const now = new Date();
    return state.data.filter(d => {
      return state.categories.includes(d.category) && state.regions.includes(d.version + 1) && (
        state.sections.length > 1 ||
        (state.sections.includes(1) && new Date(d.in_date.replace(/\s/g, "T")) < now) ||
        (state.sections.includes(2) && new Date(d.in_date.replace(/\s/g, "T")) > now)
      )
    }).length
  },
  totalCategories(state) {
    return state.categories.length
  },
  totalVersions(state) {
    return state.regions.length
  },
  totalSections(state) {
    return state.sections.length
  },
  getCampaignById: (state) => (id: number) => {
    return state.data.find(cp => cp.cp_id === id)
  }
}